module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_hokkaido@2x-fed01e44862e2466c798c426bbb99c22.webp";